import { Ng2StateDeclaration } from '@uirouter/angular';
import { FiAppearanceSidebarViewComponent } from '@fi-app/appearance/sidebar/view/view.component';
import { WidgetService } from '@fi-app/widget/widget.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export const FiAppearanceSidebarViewState: Ng2StateDeclaration = {
    name: FiStateNames.Appearance.Sidebar.View,
    url: '/',
    views: {
        '@': {
            component: FiAppearanceSidebarViewComponent,
        },
    },
    resolve: {
        widgets: [WidgetService, FiAppearanceSidebarViewStateResolveWidgets],
        pageTitle: [PageTitleService, FiAppearanceSidebarViewStateResolvePageTitle],
    },
};

export function FiAppearanceSidebarViewStateResolveWidgets(widgetService: WidgetService) {
    return widgetService.getWidgets(ObjectTypes.SideBar);
}

export function FiAppearanceSidebarViewStateResolvePageTitle(pageTitleService: PageTitleService) {
    return pageTitleService.setTitleByTextId('common.appearance');
}
